module.exports = __webpack_public_path__ + "img/release_risk_bg2.e136dc4f.jpg";